import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { ResumeQuoteApiService } from 'services/api/resume-quote-api.service';
import * as QuoteActions from 'stores/quote/quote.actions';
import * as AuthActions from 'stores/auth/auth.actions';
import isArray from 'lodash/isArray';
import { Store } from '@ngrx/store';
import { updatePersonalDetailsResponse } from 'stores/personal/personal.actions';
import * as ResumeQuoteActions from 'stores/resume-quote/resume-quote.actions';
import { selectIsTriggComms } from 'stores/quote/quote.selectors';
import { requestFailure } from 'sharedStores/error/error.actions';
import { setDropOffState } from 'sharedStores/drop-off/drop-off.actions';

@Injectable({ providedIn: 'any' })
export class ResumeQuoteEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly resumeQuoteService$: ResumeQuoteApiService,
        private readonly store$: Store,
    ) {}

    leadCheck$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ResumeQuoteActions.checkLeadRequest),
                withLatestFrom(this.store$.select(selectIsTriggComms)),
                mergeMap(([request, isTriggComms]) =>
                    this.resumeQuoteService$
                        .initResumeLead(request.encryptedLead, isTriggComms)
                        .pipe(
                            map((response) => {
                                return [
                                    ResumeQuoteActions.checkLeadResponse({
                                        quoteExpired: response.quoteExpired,
                                        quoteModifiedElsewhere: response.quoteModifiedElsewhere,
                                        idTriesLeft: response.idTriesLeft,
                                        quoteRiskDetails: response.quoteRiskDetails,
                                    }),
                                    updatePersonalDetailsResponse({
                                        personalDetails: {
                                            policyHolder: {
                                                firstName: response.firstName,
                                                lastName: response.lastName,
                                                phone: response.phone,
                                            },
                                        },
                                        traceId: '',
                                    }),
                                    QuoteActions.setLead({
                                        leadNumber: response.leadNumber,
                                        userId: null,
                                        vdn: response.vdn,
                                    }),
                                    setDropOffState({
                                        dropOffState: response.dropOffState,
                                    }),
                                ];
                            }),
                            catchError((error) => of(requestFailure(error))),
                        ),
                ),
                mergeMap((responseAction) => {
                    if (isArray(responseAction)) {
                        return [...responseAction];
                    } else {
                        return [responseAction];
                    }
                }),
            ),
        {
            dispatch: true,
        },
    );

    idCheck$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ResumeQuoteActions.checkIdRequest),
                mergeMap((request) =>
                    this.resumeQuoteService$.checkIdValidity(request.idNumber).pipe(
                        map((response) => {
                            return [
                                AuthActions.userAuthenticated({ token: response.token }),
                                ResumeQuoteActions.checkIdResponse({
                                    idMatch: response.idMatch,
                                    idTriesLeft: response.idTriesLeft,
                                    userId: response.userId,
                                }),
                            ];
                        }),
                        catchError((error) => of(requestFailure(error))),
                    ),
                ),
                mergeMap((responseAction) => {
                    if (isArray(responseAction)) {
                        return [...responseAction];
                    } else {
                        return [responseAction];
                    }
                }),
            ),
        {
            dispatch: true,
        },
    );
}
